import CaseStudyCard from "../../reusables/CaseStudyCard";
import negash from "../../../assets/images/case-studies/negash.jpg";

const NegashCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={negash}
      client="Negash Construction Company"
      solution="website design"
      title="Website design for a Construction Company entering Uganda market"
      subtitle="This South Sudan leading construction company was entering the Ugandan market and needed a digital re-brand"
      link="https://negash.co"
    >
      <li>
        ✔︎ <span>Logo re-design</span>
      </li>
      <li>
        ✔︎ <span>Professional Emails</span>
      </li>
      <li>
        ✔︎ <span>Social media setup</span>
      </li>
      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Google business profile</span>
      </li>
    </CaseStudyCard>
  );
};

export default NegashCaseStudyCard;
